module.exports = __webpack_public_path__ + "img/IC_Ausencia_Injustificada.f35c979d.svg";